// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:42:38

export default {
  "id": "dead-brain",
  "slug": "dead-brain",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/acc141fd61cd4b619164a5c7fda1d67e-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/acc141fd61cd4b619164a5c7fda1d67e/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Dead Brain",
      "description": "“Dead Brain” puts you in the shoes of a fearless farmer standing between your crops and the undead hordes. With simple controls and intense action, players must strategically use random upgrades to survive each wave and push their limits. \nAfter each victorious wave, you'll get to choose a random bonus to aid your survival. Gain a new weapon, heal your hero, repair your defenses, or even boost your health!\nAre you ready to defend your farm and become the ultimate zombie-slaying hero?",
      "instructions": "Use your mouse to aim and shoot enimies.",
      "genres": [
        "Shooter"
      ],
      "tags": [
        "2d",
        "zombie"
      ]
    },
    "zh-CN": {
      "title": "死亡大脑",
      "description": "“死亡大脑”让你扮演一位勇敢的农夫，站在你的庄稼和亡灵大军之间。凭借简单的操作和激烈的动作，玩家必须战略性地使用随机升级来生存每一波攻击并挑战自己的极限。\n在每一波胜利之后，你将有机会选择一个随机奖励来帮助你生存。获得新武器、治疗你的英雄、修复你的防御，甚至提升你的健康值！\n你准备好保卫你的农场并成为终极僵尸杀手英雄了吗？",
      "instructions": "使用鼠标瞄准并射击敌人。",
      "genres": [
        "射击游戏"
      ],
      "tags": [
        "2D",
        "僵尸"
      ]
    },
    "zh-TW": {
      "title": "死亡腦部",
      "description": "“死腦”讓你置身於一位無畏農夫的角色，站在你的作物與不死眾多僵尸之間。透過簡單的操作和強烈的动作，玩家必須策略性地使用隨機升級來生存每一波攻擊並推動自己的極限。\n在每場勝利的波次之後，你將能選擇一個隨機的獎勵來幫助你的生存。獲得新武器、治療你的英雄、修理你的防禦，甚至提升你的健康值！\n你準備好防衛你的農場並成為最終的僵屍斬殺英雄了嗎？",
      "instructions": "使用滑鼠對準並射擊敵人。",
      "genres": [
        "射擊遊戲"
      ],
      "tags": [
        "2D",
        "僵屍"
      ]
    },
    "zh-HK": {
      "title": "死腦",
      "description": "「死腦」讓你置身於無畏農夫的角色，站在你的作物與無敵的僵屍群之間。以簡單的操作和強烈的動作，玩家必須策略性地使用隨機升級來生存每一波並推動自己的極限。\n在每一波勝利後，你將能選擇一個隨機的獎勵來幫助你生存。獲得新的武器、治癒你的英雄、修理你的防禦，甚至提升你的健康！\n你準備好保衛你的農場並成為最終的僵屍斬殺英雄了嗎？",
      "instructions": "用鼠標對準目標，射擊敵人。",
      "genres": [
        "射擊遊戲"
      ],
      "tags": [
        "2D",
        "僵屍"
      ]
    },
    "ja": {
      "title": "デッドブレイン",
      "description": "「デッドブレイン」は、あなたの作物と不死の群れの間に立つ無畏の農夫の立場に置きます。シンプルな操作と激しいアクションで、プレイヤーは各ウェーブを生き延びるためにランダムなアップグレードを戦略的に使用して、自分の限界を押し上げる必要があります。\n各勝利のウェーブの後、生存を助けるランダムなボーナスを選ぶことができます。新しい武器を手に入れたり、ヒーローを回復したり、防衛を修理したり、または健康を増強したりすることができます！\nあなたは農場を守り、最終的なゾンビ殺しのヒーローになる準備はできていますか？",
      "instructions": "マウスを使って敵を照準合わせて撃つ。",
      "genres": [
        "シューティングゲーム"
      ],
      "tags": [
        "2D",
        "ゾンビ"
      ]
    },
    "ko": {
      "title": "죽은뇌",
      "description": "“Dead Brain”은 당신의 작물과 고정된 죽은 시체 병대 사이에 서 있는 무서운 농부의 신분으로 들어갑니다. 간단한 조종과 강력한 액션을 통해, 플레이어들은 각 웨이브를 생존시키기 위해 전략적으로 랜덤 업그레이드를 사용해야 합니다. \n각 승리한 웨이브 후, 당신은 생존을 돕기 위해 랜덤 보너스를 선택할 수 있습니다. 새로운 무기를 얻거나 영웅을 치유하거나 방어막을 수리하거나 심지어 건강을 강화할 수 있습니다!\n당신의 농장을 방어하고 최종 죽은 시체 죽이는 영웅이 되어야 할 준비가 되셨나요?",
      "instructions": "마우스를 사용하여 적을 정확히 대상을 맞추고 발사하세요.",
      "genres": [
        "射手"
      ],
      "tags": [
        "2D",
        "장염귀"
      ]
    },
    "fr": {
      "title": "Cerveau mort",
      "description": "“Dead Brain” vous met dans la peau d'un courageux fermier qui se tient entre vos cultures et les hordes de morts-vivants. Avec des contrôles simples et des actions intenses, les joueurs doivent utiliser stratégiquement des améliorations aléatoires pour survivre à chaque vague et pousser leurs limites.\nAprès chaque vague victorieuse, vous pourrez choisir un bonus aléatoire pour aider votre survie. Gagnez un nouvel arme, guérissez votre héros, réparez vos défenses ou même boostez votre santé !\nPrêt à défendre votre ferme et à devenir le héros ultime des tueurs de zombies ?",
      "instructions": "Utilisez votre souris pour viser et tirer sur les ennemis.",
      "genres": [
        "Tirailleur d'élite"
      ],
      "tags": [
        "2D",
        "zombie"
      ]
    }
  }
};
